import { render, staticRenderFns } from "./CollectFolderDialog.vue?vue&type=template&id=3b449f7e&scoped=true"
import script from "./CollectFolderDialog.vue?vue&type=script&lang=js"
export * from "./CollectFolderDialog.vue?vue&type=script&lang=js"
import style0 from "./CollectFolderDialog.vue?vue&type=style&index=0&id=3b449f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b449f7e",
  null
  
)

export default component.exports